import { Button } from "react-bootstrap";

function ConfirmReset({ resourceName, onConfirm, disabled, onCloseModal }) {
  return (
    <div className="styled-small-popup">
      <h3>Reset {resourceName}</h3>

      <p>Are you sure you want to reset this {resourceName} ? This action cannot be undone.</p>

      <div>
        <Button variant="outline-dark" disabled={disabled} onClick={onCloseModal}>
          Cancel
        </Button>
        <Button variant="success" disabled={disabled} onClick={onConfirm}>
          RESET
        </Button>
      </div>
    </div>
  );
}

export default ConfirmReset;
